export const tableCardContainerCSS = {
	p: 4,
	width: 1,
	height: 1,
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	flexGrow: '1',
} as const
